const handleFeedbackListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.feedbackList = action.payload.data.data;
  state.feedbackReportsOrder = action.payload.data.data.map(feedbackReport => feedbackReport.id);
  state.currentPage = action.payload.data.current_page;
  state.perPage = action.payload.data.limit;
  state.totalPages = action.payload.data.total_pages;
  state.totalFeedbackReports = action.payload.data.total_feedback_list_count;
  state.lastUpdated = action.payload.data.last_updated;
  state.message = action.payload.message;
};

export {
  handleFeedbackListFulfilled
};
